import useChartOptions from '@/components/Chart/hooks/options/useChartOptions';
import useSpotOptions from '@/components/Chart/hooks/options/useSpotOptions';
import useChartSeries from '@/components/Chart/hooks/useChartSeries';
import type { TemplateChartSeries } from '@/types/charts';

import AuthenticatedChart from './AuthenticatedChart';

const AuthenticatedSpotChart = ({
  templateChartSeries
}: {
  templateChartSeries: TemplateChartSeries[];
}) => {
  const { loading, error, chartSeries } = useChartSeries(templateChartSeries);
  const { createOptions } = useSpotOptions(14);
  const { options: chartOptions } = useChartOptions(chartSeries, createOptions);
  return (
    <AuthenticatedChart
      chartOptions={chartOptions}
      chartSeries={chartSeries}
      chartType='spot'
      error={error}
      loading={loading}
    />
  );
};

export default AuthenticatedSpotChart;
